// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ProfileMainSec_Wrapper__3h1Db","LeftSec":"ProfileMainSec_LeftSec__1J_1V","RightSec":"ProfileMainSec_RightSec__HP3Q1"};